import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Planning my senior fitness classes used to take me hours every week. Now I simply open the system and teach. My participants love the structure and I finally have my weekends back.',
  author: 'Jennifer M.',
  role: 'Senior Fitness Instructor',
  location: 'Florida, USA'
}, {
  text: 'The Fall Prevention bonus alone is worth the price. Everything is organized and easy to implement. I feel so much more confident knowing I am delivering safe, effective programming.',
  author: 'Michael R.',
  role: 'Active Aging Coach',
  location: 'Texas, USA'
}, {
  text: 'I work with multiple ability levels and this system finally gave me a framework I can rely on. The chair fitness progressions have been a game-changer for my less mobile participants.',
  author: 'Sarah T.',
  role: 'Community Fitness Coordinator',
  location: 'Ontario, Canada'
}, {
  text: 'The Ready-To-Use Sessions saved me countless hours. I wish I had found this years ago. It takes all the guesswork out of planning and lets me focus entirely on coaching and connecting with my class.',
  author: 'David L.',
  role: 'Personal Trainer',
  location: 'Melbourne, Australia'
}, {
  text: 'As someone transitioning into senior fitness, I was overwhelmed by what was safe to teach. This 6-in-1 system gave me the exact blueprint I needed. My classes are full and my clients are seeing real improvements in their daily mobility.',
  author: 'Linda K.',
  role: 'Group Fitness Instructor',
  location: 'Phoenix, USA'
}];
export function Testimonials() {
  return <section className="py-12 px-4 sm:px-6 bg-cream border-y-4 border-ivory" data-id="element-178">
      <div className="text-center mb-10" data-id="element-179">
        <h2 className="text-3xl sm:text-4xl font-heading font-bold text-petrol mb-3 leading-tight uppercase" data-id="element-180">
          WHAT OTHER PROFESSIONALS ARE SAYING
        </h2>
        <p className="text-sm sm:text-base font-body font-bold text-sage uppercase tracking-widest" data-id="element-181">
          Testimonials from professionals
        </p>
      </div>

      <div className="flex flex-col gap-5 max-w-4xl mx-auto" data-id="element-182">
        {testimonials.map((t, i) => <div key={i} className="bg-ivory border border-gold/30 p-6 rounded-xl shadow-md" data-id="element-183">
            <div className="flex gap-1 mb-3" data-id="element-184">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-185" />)}
            </div>
            <p className="text-graphite font-medium mb-4 leading-relaxed italic text-base sm:text-lg font-subheading" data-id="element-186">
              "{t.text}"
            </p>
            <div className="border-t border-gold/20 pt-4 flex items-center gap-4" data-id="element-187">
              <div className="w-12 h-12 rounded-full bg-petrol/10 flex items-center justify-center text-petrol font-bold text-lg border border-petrol/20 font-heading" data-id="element-188">
                {t.author.charAt(0)}
              </div>
              <div className="leading-tight" data-id="element-189">
                <p className="font-bold text-petrol text-sm sm:text-base font-body" data-id="element-190">
                  — {t.author}
                </p>
                <p className="text-xs text-graphite/70 font-bold uppercase tracking-widest mt-1" data-id="element-191">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}